<template>
	<div class="homeBox" @click="upTopNav">
    <div style="height:2.3rem;overflow:hidden">
      <div class="tnavListBox">
        <div class="tnavList">
          <router-link :to="{name:'companyIntroduce'}" class="tnavListLi">集团简介</router-link>
          <router-link :to="{name:'developmentHistoryBox'}" class="tnavListLi">发展历程</router-link>
          <router-link :to="{name:'honorBox'}" class="tnavListLi">媒体荣誉</router-link>
          <router-link :to="{name:'contactBox'}" class="tnavListLi">联系我们</router-link>
          <router-link :to="{name:'group'}" class="tnavListLi">集团风采</router-link>
        </div>
        <!-- <top-shadow class="topShadow"></top-shadow> -->
      </div>
    </div>
    <router-view/>  
		<!-- 背景是图片 -->
	</div>
</template>
<script>
import '../../../static/js/swiper.min.js'

// import companyIntroduce from '@components/about/companyIntroduce'
export default {
  name: 'Home',
  data () {
    return {
      lastId: 0
    }
  },
  mounted(){
      // this.$router.beforeEach((to, from, next) => { //to:即将前往的页面,from:从哪个页面来,next:下一步操作
      //    // if (to.matched.some(res => res.login)) {  //判断是否登录
      //         next()
      //    // }
      // })
  },
  methods:{
    upTopNav:function(){
      document.getElementById("navLinkBox").classList.remove('active');
      document.getElementById("navLinkBox").style.transition = "0.5s";
    }
  }
}
document.onclick = function(e){
  document.getElementById("navLinkBox").classList.remove('active');
  document.getElementById("navLinkBox").style.transition = "0.5s";
}
</script>
<style scoped>
	
.homeBox{
	width: 100%;
  height: auto;
  margin: 3.2rem auto 0;
  font-size: 0;
}	
.topShadow{
  -webkit-box-shadow: 0.1rem 0.2rem 0.1rem rgba(190,190,190,0.25);
  box-shadow: 0.1rem 0.2rem 0.1rem rgba(190,190,190,0.25);
  height: 0.1rem;
  display: inline-block;
  width: 100%;
  background: #fff;
  position: fixed;
  top: 4.45rem;
}
.tnavListBox{
  overflow: hidden;
  width: 100%;
  overflow-x: scroll;
  position: fixed;
  top: 3.2rem;
  background: #fff;
  height: 2.3rem;
  line-height: 1.8rem;
  box-shadow: 0 0 18px rgba(42, 42, 42, 0.1);  
}
.tnavList{
  height: 2.3rem;
  line-height: 1.8rem;
  width: 29rem;
  overflow: hidden;
}
.tnavListBox::-webkit-scrollbar {/*滚动条整体样式*/
  width: 0.1rem;     /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.1rem;
}
.tnavListLi{
  padding: 0.6rem 0 ;
  font-size: 0.9333rem;
  margin: 0 1rem;
}
.router-link-active{
  color: #333;
  border-bottom: 2px solid #ff7800;
}
a{
  color: #bfbfbf;
}

</style>


// WEBPACK FOOTER //
// src/components/about/About.vue